/**
 * Self-schedule buffer defaults. Backend is not wired yet — today the
 * values live only on the client and seed from these constants. When
 * the API contract lands, hydrate from `interview.buffer_before` /
 * `buffer_after` and fall back here.
 */

export const DEFAULT_BUFFER_BEFORE_MINUTES = 15;
export const DEFAULT_BUFFER_AFTER_MINUTES = 15;
export const BUFFER_STEP_MINUTES = 5;
export const BUFFER_MIN_MINUTES = 0;
export const BUFFER_MAX_MINUTES = 60;
